import { render, staticRenderFns } from "./DoubleGroupChart.vue?vue&type=template&id=335aaeb3&"
import script from "./DoubleGroupChart.vue?vue&type=script&lang=ts&"
export * from "./DoubleGroupChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports